export default __webpack_public_path__ + "static/media/hht1_ep8_minisitcom_03.420cd8e9.png";